/* eslint-disable @typescript-eslint/ban-ts-comment */
import TooltipDisabledButton from '@components/Generals/TooltipDisabledButton';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../Button';
import ShowIf from '../ShowIf';

interface NavItemProps {
  title: string;
  icon?: string;
  disableMessage?: string;
  url: string;
  shouldDisable?: boolean;
  hideIf?: boolean;
  className?: string;
}

const NavItem = ({
  title,
  icon,
  disableMessage,
  url,
  shouldDisable = false,
  hideIf = false,
  className,
}: NavItemProps) => {
  const location = useLocation();

  const isActive = url == location.pathname; // eslint-disable-line

  if (hideIf) {
    return null;
  }

  return (
    <TooltipDisabledButton title={disableMessage} disabled={!shouldDisable}>
      <Button
        // @ts-ignore
        component={Link}
        variant="text"
        disabled={shouldDisable}
        fullWidth
        to={url}
        className={className}
        sx={[
          {
            justifyContent: 'start',
            color: 'black',
            fontWeight: '400',
            px: '1.25rem',
            py: '0.5rem',
            '& .MuiButton-startIcon': {
              filter: 'grayscale(100%)',
            },
          },
          (theme) => {
            if (!isActive) {
              return {};
            }

            return {
              backgroundColor: theme.nav.activeLinkBackGround,
              '&:hover': {
                backgroundColor: theme.nav.activeLinkBackGround,
              },
            };
          },
        ]}
        startIcon={
          <ShowIf If={!!icon}>
            <img src={`/images/icon-v2/${icon}`} alt="chalk-talk" width="16px" />
          </ShowIf>
        }
      >
        <span>{title}</span>
      </Button>
    </TooltipDisabledButton>
  );
};

export default NavItem;
